import React from "react"
import { Link } from "gatsby"
import { Nav } from "react-bootstrap"
import "./menu.css"

export default ({ toggle }) => (
	<div className="navigation">
		<Link onClick={toggle} to="/">
			<img className="img-fluid mb-4" src="assets/logo.png" alt="imgtext" />
		</Link>
		<Nav className="flex-column">
			<Nav.Item>
				<Link onClick={toggle} to="/#">
					Home
				</Link>
			</Nav.Item>
			<Nav.Item>
				<Link onClick={toggle} to="/#mission">
					About Us
				</Link>
			</Nav.Item>
			<Nav.Item>
				<Link onClick={toggle} to="/#services">
					Services
				</Link>
			</Nav.Item>
			<Nav.Item>
				<Link onClick={toggle} to="/#">
					Industries
				</Link>
			</Nav.Item>
			<Nav.Item>
				<Link onClick={toggle} to="/#">
					Insights
				</Link>
			</Nav.Item>
			<Nav.Item>
				<Link onClick={toggle} to="/blog">
					Blog
				</Link>
			</Nav.Item>
			<Nav.Item>
				<Link onClick={toggle} to="/#contact">
					Contact Us
				</Link>
			</Nav.Item>
		</Nav>
	</div>
)
